import type { ClientEnv } from '@/types/client-env';

export const getClientEnvs = async () => {
  const response = await fetch('/envs', {
    cache: 'no-store',
  });
  if (!response.ok) {
    console.error('Failed to fetch client env');
    return {} as ClientEnv;
  }

  return (await response.json()) as ClientEnv;
};
